
/**
* Localize i18n
* https://i18n.nuxtjs.org/docs/getting-started/usage
*/
import locales from './locales/index'

export default defineI18nConfig(() => ({
    legacy: false,
    messages: locales,
    warnHtmlMessage: false
}))